// Facility Staff management page — full legacy port (V1.1).
//
// Legacy: src/app/[locale]/[country]/account/facility/[facilityId]/staff/
// (page.tsx → facility-staff-page-client.tsx → facility-staff-client.tsx).
// All page logic lives in FacilityStaffClient; this route only binds the
// $facilityId param. The legacy wrapper's session-role + branches plumbing
// moved into the client component (caller role resolved from the staff list
// itself — the apps/api JWT carries no facilityTeams claim).
//
// No feature gate here: the legacy staff page mounted no useFeatureAccess /
// FeatureTeaserPage wrapper (unlike provider team.tsx) — access is purely
// facility-membership RBAC, enforced server-side on every endpoint.

import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { FacilityStaffClient } from "@/components/account/facility/facility-staff-client";

export const Route = createFileRoute("/_authenticated/account/facility/$facilityId/staff")({
  component: FacilityStaffPage,
});

function FacilityStaffPage() {
  const { facilityId } = Route.useParams();

  return (
    <div className="space-y-8">
      <FacilityStaffClient facilityId={facilityId} />
      <AccountSecurityBanner />
    </div>
  );
}
